// extracted by mini-css-extract-plugin
export var buttonContent = "_3h-0";
export var centered = "_3h-1";
export var centeredFlex = "_3h-2";
export var errorText = "_3h-3";
export var icon = "_3h-4";
export var iconButtonContent = "_3h-5";
export var monospace = "_3h-6";
export var padded = "_3h-7";